export default __webpack_public_path__ + "static/media/Catechisms.517cf1df.pdf";